import React from 'react'

const CrazyOverview = (): React.ReactElement => {
    return (
        <div>
            <iframe
                title="CRAZY on Dexscreener"
                width="100%"
                height="1000px"
                src="https://dexscreener.com/pulsechain/0xa0089402aaaed2e9bfbc9937454ef9f428ba2a7e?embed=1&amp;theme=dark"
                className="custom-1nezxjv"
            />
        </div>
    )
}

export default CrazyOverview
